import { IAutoMapper } from "../interfaces";

export const mapChaseQueryItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("chase-query-item", "ChaseItem")
    .forMember("chaseId", o => o.chaseId);
};
